import BaseException from './base_exception'
class InvalidFile extends BaseException {
  constructor(typeOfData) {
    super('hs.file.errors.invalid_type', { typeOfData })
  }
}

export default InvalidFile
